import { useEffect, useRef } from 'react';

const useRefreshToken = (callback: () => void, depsArray: any[] = []) => {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      savedCallback.current();
    }, 900000);
    return () => clearInterval(intervalId);
  }, [...depsArray]);
};

export default useRefreshToken;
